// const { set } = require('lodash');
const { once, min } = require('lodash');
const { spinnerToggle } = require('./common');
const { clientId } = require('./socket');
const { start } = require('@popperjs/core');

let pageNumber = 1;

// #region dateRangePicker 초기화
let dateFormatCallback = function (start, end, label) {
  startDate = start.format('YYYY-MM-DD');
  endDate = end.format('YYYY-MM-DD');

  if ($.fn.DataTable.isDataTable('#resultModalTable')) {
    $('#resultModalTable').DataTable().ajax.reload();
  }

  // #miniModalTable이 존재하면 리로드
  if ($.fn.DataTable.isDataTable('#miniModalTable')) {
    $('#miniModalTable').DataTable().ajax.reload();
  }
};

const commonOptions = {
  minYear: moment().year() - 1,
  maxYear: moment().year() + 2,
  ranges: {
    오늘: [moment().startOf('day'), moment().endOf('day')],
    어제: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    '7일 전': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    '15일 전': [moment().subtract(14, 'days').startOf('day'), moment().endOf('day')],
    '30일 전': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    '이번 달': [moment().startOf('month'), moment().endOf('month')],
    '저번 달': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  },
  autoApply: true,
  showDropdowns: true,
  alwaysShowCalendars: true,
  locale: {
    format: 'YYYY-MM-DD',
    separator: ' ~ ',
    applyLabel: '확인',
    cancelLabel: '취소',
    fromLabel: 'From',
    toLabel: 'To',
    daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
    monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  },
};

// #endregion

// #region 카지노 리스트
getCasinoList();

function getCasinoList() {
  $.ajax({
    method: 'POST',
    url: '/game/list',
    data: { type: 'casino' },
  })
    .done(function (result) {
      const { reqList, api_type } = result;
      let elements = '';

      reqList.forEach((list, i) => {
        const indexImg = String(i + 1).padStart(3, '0');
        const indexBg = String(i + 1).padStart(3, '0');

        if (api_type === 'hl') {
          const providerNameMap = {
            Evolution: '에볼루션 카지노',
            'PragmaticPlay Live': '프라그마틱 플레이',
            EZUGI: '에즈기',
            'VIVO CASINO': '비보 카지노',
            'DREAM GAMING': '드림 게이밍',
            'Micro Gaming': '마이크로 게이밍',
            'ASIA GAMING': '아시아 게이밍',
            'WM Casino': 'WM 카지노',
            'Dowin Casino': '두윈 카지노',
            'BOTA CASINO': '보타 카지노',
            'All Bet': '올벳',
          };

          list.provider_name = providerNameMap[list.provider_name] || list.provider_name;

          // 원하는 벤더만 필터링
          // if (list.provider_name !== '에볼루션 카지노') return;

          elements += `
              <div class="col">
                <div class="casino-banner">
                  <div class="overlay">
                    <div class="name">${list.provider_name}</div>
                    <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                      <i class="bi bi-play-circle-fill play"></i>
                    </a>
                  </div>
                  <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-bg" />
                  <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
                  <div class='casino-name'>${list.provider_name}</div>
                </div>
              </div>
          `;
        } else if (api_type === 'nx') {
          elements += `
            <div class="col">
              <div class="casino-banner">
                <div class="overlay">
                  <div class="name">${list.provider_name}</div>
                  <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                  <i class="bi bi-play-circle-fill play"></i>
                  </a>
                  </div>
                <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-img" />
                <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
                <div class="casino-name">${list.provider_name}</div>
              </div>
            </div>
          `;
        } else if (api_type === 'sk') {
          const providerNameMap = {
            Evolution: '에볼루션 카지노',
            'PragmaticPlay Live': '프라그마틱 플레이',
            EZUGI: '에즈기',
            'VIVO CASINO': '비보 카지노',
            'DREAM GAMING': '드림 게이밍',
            'Micro Gaming': '마이크로 게이밍',
            'ASIA GAMING': '아시아 게이밍',
            'WM Casino': 'WM 카지노',
            'Dowin Casino': '두윈 카지노',
            'BOTA CASINO': '보타 카지노',
            'All Bet': '올벳',
          };

          list.provider_name = providerNameMap[list.provider_name] || list.provider_name;

          // 원하는 벤더만 필터링
          // if (list.provider_name !== '에볼루션 카지노') return;

          elements += `
          <div class="col">
            <div class="casino-banner">
              <div class="overlay">
                <div class="name">${list.provider_name}</div>
                <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                <i class="bi bi-play-circle-fill play"></i>
                </a>
                </div>
              <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-img" />
              <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
              <div class="casino-name">${list.provider_name}</div>
            </div>
          </div>
        `;
        } else if (api_type === 'sc') {
          // 원하는 벤더만 필터링
          // if (list.provider_name !== '에볼루션 카지노') return;

          elements += `
          <div class="col">
            <div class="casino-banner">
              <div class="overlay">
                <div class="name">${list.provider_name}</div>
                <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                <i class="bi bi-play-circle-fill play"></i>
                </a>
                </div>
              <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-img" />
              <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
              <div class="casino-name">${list.provider_name}</div>
            </div>
          </div>
        `;
        } else if (api_type === 'po') {
          elements += `
            <div class="col">
              <div class="casino-banner">
                <div class="overlay">
                  <div class="name">${list.provider_name}</div>
                  <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                  <i class="bi bi-play-circle-fill play"></i>
                  </a>
                  </div>
                <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-img" />
                <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
                <div class="casino-name">${list.provider_name}</div>
              </div>
            </div>
          `;
        } else if (api_type === 'gp') {
          elements += `
          <div class="col">
            <div class="casino-banner">
              <div class="overlay">
                <div class="name">${list.provider_name}</div>
                <a href="#" class="liveCasino" data-game_id="${list.lobby_code}" data-provider="${list.provider_code}" data-game_type="live">
                  <i class="bi bi-play-circle-fill play"></i>
                </a>
              </div>
              <img src="/public/images/casino/bg/casino_img_${indexBg}.jpg" class="w-100 rounded-3 casino-bg" />
              <img src="/public/images/casino/logo/${list.provider_img}" class="w-100 rounded-3 casino-logo" />
              <div class='casino-name'>${list.provider_name}</div>
            </div>
          </div>
      `;
        }
      });

      document.querySelector('#nav-casino .row').innerHTML = elements;
      addEventListenersToGameStartButtons('liveCasino');
    })
    .fail(function (err) {
      console.log(err);
    });
}
// #endregion

// #region (슬롯)프로바이더 리스트
getProviderList();

function getProviderList() {
  $.ajax({
    method: 'POST',
    url: '/game/list',
    data: { type: 'provider' },
  })
    .done(function (result) {
      const providers = [...result.providerSet];
      makeSlotProvider(providers, result.api_type);
    })
    .fail(function (err) {
      console.log(err);
    });
}

function makeSlotProvider(providers, api_type) {
  const navSlotList = document.querySelector('#navSlotList');
  const providerInfo = {
    hl: {
      amatic: { name: '아마틱', img: 'amatic' },
      jili: { name: 'JILI', img: 'jili' },
      bgaming: { name: '비게이밍', img: 'bgaming' },
      expanse: { name: '익스펜스', img: 'expanse' },
      Hacksaw: { name: '핵쏘', img: 'hacksaw' },
      JDB: { name: 'JDB', img: 'jdb' },
      Kalamba: { name: '칼람바', img: 'kalamba' },
      mplay: { name: '엠플레이', img: 'mplay' },
      revolver: { name: '리볼버', img: 'revolver' },
      RubyPlay: { name: '루비플레이', img: 'rubyplay' },
      Slotmill: { name: '스롯밀', img: 'slotmill' },
      kagaming: { name: 'KAG 게이밍', img: 'kagaming' },
      'MicroGaming Plus Slo': { name: '마이크로 게이밍', img: 'microgaming' },
      'micro-gaming': { name: '마이크로 게이밍', img: 'microgaming' },
      PragmaticPlay: { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      spinomenal: { name: '스피노메날', img: 'spinomenal' },
      playngo: { name: '플레이 앤 고', img: 'playngo' },
      wazdan: { name: '와즈단', img: 'wazdan' },
      redtiger: { name: '레드 타이거', img: 'redtiger' },
      CQ9: { name: '씨큐나인', img: 'cq9' },
      greentube: { name: '그린튜브', img: 'greentube' },
      evoplay: { name: '에보플레이', img: 'evoplay' },
      'Blueprint Gaming': { name: '블루프린트 게이밍', img: 'blueprint' },
      Habanero: { name: '하바네로', img: 'habanero' },
      endorphina: { name: '엔도르피나', img: 'endorphina' },
      platingaming: { name: '플레이팅 게이밍', img: 'platingaming' },
      dreamtech: { name: '드림테크', img: 'dreamtech' },
      netent: { name: '넷엔트', img: 'netent' },
      egtjackpot: { name: 'EGT 잭팟', img: 'egtjackpot' },
      booming: { name: '부밍', img: 'booming' },
      'PG Soft': { name: 'PG 소프트', img: 'pgsoft' },
      eagaming: { name: 'EA 게이밍', img: 'eagaming' },
      'Asia Gaming Slot': { name: '아시아 게이밍 슬롯', img: 'asiagamingslot' },
      platipus: { name: '프라티푸스', img: 'platipus' },
      GameArt: { name: '게임아트', img: 'gameart' },
      redrake: { name: '레드 레이크', img: 'redrake' },
      merkur: { name: '멀커', img: 'merkur' },
      bfgames: { name: 'BF 게임즈', img: 'bfgames' },
      'Elk Studios': { name: '엘크 스튜디오', img: 'elkstudios' },
      Booongo: { name: '부운고', img: 'booongo' },
      'Nolimit City': { name: '노리밋 시티', img: 'nolimitcity' },
      'intouch-games': { name: '인터치 게임즈', img: 'intouchgames' },
      Playson: { name: '플레이슨', img: 'playson' },
      PlayPearls: { name: '플레이 펄스', img: 'playpearls' },
      Thunderkick: { name: '썬더킥', img: 'thunderkick' },
      retrogames: { name: '레트로 게임즈', img: 'retrogames' },
      Mobilots: { name: '모빌롯츠', img: 'mobilots' },
      PlayStar: { name: '플레이 스타', img: 'playstar' },
      caletagaming: { name: '카르타 게이밍', img: 'caletagaming' },
      netgame: { name: '넷 게임', img: 'netgame' },
      'Relax Gaming': { name: '릴렉스 게이밍', img: 'relaxgaming' },
      'Dragoon Soft': { name: '드라군 소프트', img: 'dragoonsoft' },
      '1X2 Gaming': { name: '1X2 게이밍', img: '1x2gaming' },
      fils: { name: '필스', img: 'fils' },
      smartsoft: { name: '스마트 소프트', img: 'smartsoft' },
      mancala: { name: '만칼라', img: 'mancala' },
      onetouch: { name: '원터치', img: 'onetouch' },
      popok: { name: '포폭', img: 'popok' },
      'Triple Profit Gaming': { name: '트리플 프로핏 게이밍', img: 'tripleprofitgaming' },
      quickspin: { name: '퀵스핀', img: 'quickspin' },
      7777: { name: '7777', img: '7777' },
      'classic casino': { name: '클래식 카지노', img: 'classiccasino' },
      '7-mojos-slots': { name: '세븐 모조스 슬롯', img: '7mojosslots' },
      iconix: { name: '아이코닉', img: 'iconix' },
      macaw: { name: '마카우', img: 'macaw' },
      BigTimeGaming: { name: '빅타임 게이밍', img: 'bigtimegaming' },
      galaxsys: { name: '갤럭시스', img: 'galaxsys' },
      Skywind: { name: '스카이윈드', img: 'skywind' },
    },
    nx: {
      pragmatic_slot: { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      cq9_slot: { name: '씨큐나인', img: 'cq9' },
      playngo_slot: { name: '플레이앤고', img: 'playngo' },
      skywind_slot: { name: '스카이윈드', img: 'skywind' },
      evolution_redtiger: { name: '레드타이거', img: 'redtiger' },
      wazdan_slot: { name: '와즈단', img: 'wazdan' },
      evo_slot: { name: '에보플레이', img: 'evoplay' },
      endorphina_slot: { name: '엔도르피나', img: 'endorphina' },
      habanero_slot: { name: '하바네로', img: 'habanero' },
      netent_slot: { name: '넷엔트', img: 'netent' },
      pgsoft_slot: { name: 'PG소프트', img: 'pgsoft' },
      funkegames_slot: { name: '펀키게임즈', img: 'funkygames' },
      booongo_slot: { name: '부운고', img: 'booongo' },
      bgaming_slot: { name: '비게이밍', img: 'bgaming' },
      hs_slot: { name: '핵소우', img: 'hacksaw' },
      nlc_slot: { name: '노리밋 시티', img: 'nolimitcity' },
      playson_slot: { name: '플레이손', img: 'playson' },
      relax_slot: { name: '릴렉스 게이밍', img: 'relaxgaming' },
      ag_slot: { name: '아시안 게이밍', img: 'asiagamingslot' },
      mggrand_slot: { name: '마이크로게이밍 그랜드', img: 'microgaming' },
      ps_slot: { name: '플레이스타', img: 'playstar' },
      booming_slot: { name: '부밍 게임즈', img: 'booming' },
      dragoonsoft_slot: { name: '드래곤소프트', img: 'dragoonsoft' },
      btg_slot: { name: '빅타임 게이밍', img: 'bigtimegaming' },
      netgaming: { name: '넷게이밍', img: 'netgame' },
      blueprint_slot: { name: '블루프린트', img: 'bfgames' },
      ygg_slot: { name: '이그드라실', img: 'ygg' },
      jili_slot: { name: 'JILI', img: 'jili' },
      // joker_slot: { name: '조커', img: 'joker' },
      // betsoft_slot: { name: '벳소프트', img: 'betsoft' },
      // aspect_slot: { name: '어스펙트', img: 'aspect' },
      // gmw_slot: { name: 'GMW', img: 'gmw' },
      // ftg_slot: { name: 'FTG', img: 'ftg' },
      // octoplay_slot: { name: '옥토플레이', img: 'octoplay' },
      // nspin_slot: { name: '넥스트스핀', img: 'nextspin' },
      // ygr_slot: { name: 'YRG', img: 'yrgslot' },
      // spearhead_slot: { name: '스피어헤드', img: 'spearhead' },
      // naga_slot: { name: '나가', img: 'naga' },
      // aux_slot: { name: '아바타 UX', img: 'avatarux' },
      // advantplay_slot: { name: '어드밴트플레이', img: 'advantplay' },
      // reelplay_slot: { name: '릴플레이', img: 'reelplay' },
      // expanse_slot: { name: '익스팬스', img: 'expanse' },
      // fantasma_slot: { name: '판타즈마', img: 'fantasma' },
      // boomerang_slot: { name: '부메랑', img: 'boomerang' },
      // '4tp_slot': { name: '포더플레이어', img: '4tp' },
    },
    sk: {
      'PRAGMATIC(SLOT)': { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      DIR_CQ9: { name: '씨큐나인', img: 'cq9' },
      PGSOFT: { name: 'PG소프트', img: 'pgsoft' },
      DIR_BOOONGO: { name: '부운고', img: 'booongo' },
      5: { name: '플레이손', img: 'playson' },
      HABANERO: { name: '하바네로', img: 'habanero' },
      // SKYWIND: { name: '스카이윈드', img: 'skywind' },
      // REDTIGER: { name: '레드 타이거', img: 'redtiger' },
      // YGGDRASIL: { name: '이그드라실', img: 'ygg' },
      // DIR_WAZDAN: { name: '와즈단', img: 'wazdan' },
      // DIR_EVOPLAY: { name: '에보플레이', img: 'evoplay' },
      // MGSLOT: { name: '마이크로 게이밍', img: 'microgaming' },
      // NOLIMITCITY: { name: '노리밋 시티', img: 'nolimitcity' },
      // DIR_HACKSAW: { name: '핵쏘', img: 'hacksaw' },
      // DIR_RELAX: { name: '릴렉스 게이밍', img: 'relaxgaming' },
      // NETENT: { name: '넷엔트', img: 'netent' },
      // ONETOUCH: { name: '원터치', img: 'onetouch' },
      // BIGTIMEGAMING: { name: '빅타임 게이밍', img: 'bigtimegaming' },
    },
    sc: {
      1: { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      2: { name: '씨큐나인', img: 'cq9' },
      3: { name: 'PG소프트', img: 'pgsoft' },
      4: { name: '부운고', img: 'booongo' },
      5: { name: '플레이손', img: 'playson' },
      7: { name: '하바네로', img: 'habanero' },
      9: { name: '질리', img: 'jili' },
    },
    gp: {
      1: { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      2: { name: '씨큐나인', img: 'cq9' },
      3: { name: 'PG소프트', img: 'pgsoft' },
      4: { name: '부운고', img: 'booongo' },
      5: { name: '플레이손', img: 'playson' },
      7: { name: '하바네로', img: 'habanero' },
      9: { name: '질리', img: 'jili' },
      // pragmaticplay: { name: '프라그마틱 플레이', img: 'pragmaticplay' },
      // cq9: { name: '씨큐나인', img: 'cq9' },
      // hbn: { name: '하바네로', img: 'habanero' },
      // pg: { name: 'PG 소프트', img: 'pgsoft' },
      // Hacksaw: { name: '핵쏘', img: 'hacksaw' },
      // dreamtech: { name: '드림테크', img: 'dreamtech' },
      // bng: { name: '부운고', img: 'booongo' },
      // playson: { name: '플레이손', img: 'playson' },
    },
  };
  providerInfo.po = { ...providerInfo.sc };

  // 템플릿 생성 함수
  const generateHTML = (providerName, providerImg, provider, index) => {
    const indexStr = String(index + 1).padStart(3, '0');
    const indexBg = String((index + 1) % 5 || 5).padStart(2, '0');
    return `
        <div class="col">
          <div class="provider-banner">
            <div class="overlay">
              <div class="name">${providerName}</div>
              <a href="#" class="openSlotModal" data-provider="${provider}">
                <i class="bi bi-play-circle-fill play"></i>
              </a>                            
            </div>
            <img src="/public/images/slots/bg/slot_bg_${indexBg}.jpg" class="w-100 rounded-3 provider-bg" />
            <img src="/public/images/slots/character/slot_img_${indexStr}.png" class="w-100 rounded-3 provider-character" />
            <img src="/public/images/slots/logo/${providerImg}.png" class="w-100 rounded-3 provider-logo" />
            <div class='provider-name'>${providerName}</div>
          </div>  
        </div>`;
  };

  const allowedProviders = [
    'PragmaticPlay',
    '1',
    '2',
    '3',
    '4',
    '5',
    '7',
    '9',
    'CQ9',
    'PG Soft',
    'Booongo',
    'Habanero',
    'jili',
    'Nolimit City',
    'playngo',
  ];

  providers.forEach((provider, i) => {
    // 허용된 프로바이더만 리스트업
    // if (!allowedProviders.includes(provider)) return;

    const providerData = providerInfo[api_type]?.[provider];
    if (!providerData) return;

    const { name: providerName, img: providerImg } = providerData;
    const newList = generateHTML(providerName, providerImg, provider, i);
    navSlotList.innerHTML += newList;
  });

  // 이벤트 핸들러 추가
  $('.openSlotModal').on('click', function (e) {
    let provider = $(this).data('providername') || $(this).data('provider');

    $.ajax({
      method: 'POST',
      url: '/user/logincheck',
    }).done(function (result) {
      if (result) {
        $('#slotModal').data('provider', provider).modal('show');
      } else {
        $('#notLoginModal').modal('show');
      }
    });
  });
}
// #endregion

// #region 슬롯 모달 리스트업
$('#slotModal').on('show.bs.modal', function (event) {
  let provider = $(this).data('provider');

  const providerTitle = {
    hl: {
      PragmaticPlay: '프라그마틱 플레이',
      amatic: '아마틱',
      bgaming: '비게이밍',
      expanse: '익스펜스',
      Hacksaw: '핵쏘',
      JDB: 'JDB',
      Kalamba: '칼람바',
      mplay: '엠플레이',
      revolver: '리볼버',
      RubyPlay: '루비플레이',
      Slotmill: '스롯밀',
      // kagaming: 'KAG 게이밍',
      'MicroGaming Plus Slo': '마이크로 게이밍',
      'micro-gaming': '마이크로 게이밍',
      spinomenal: '스피노메날',
      playngo: '플레이 앤 고',
      wazdan: '와즈단',
      redtiger: '레드 타이거',
      CQ9: '씨큐나인',
      greentube: '그린튜브',
      evoplay: '에보플레이',
      'Blueprint Gaming': '블루프린트 게이밍',
      Habanero: '하바네로',
      endorphina: '엔도르피나',
      platingaming: '플레이팅 게이밍',
      dreamtech: '드림테크',
      netent: '넷엔트',
      egtjackpot: 'EGT 잭팟',
      booming: '부밍',
      'PG Soft': 'PG 소프트',
      eagaming: 'EA 게이밍',
      'Asia Gaming Slot': '아시아 게이밍 슬롯',
      platipus: '프라티푸스',
      GameArt: '게임아트',
      redrake: '레드 레이크',
      merkur: '멀커',
      bfgames: 'BF 게임즈',
      'Elk Studios': '엘크 스튜디오',
      Booongo: '부운고',
      'Nolimit City': '노리밋 시티',
      'intouch-games': '인터치 게임즈',
      Playson: '플레이슨',
      PlayPearls: '플레이 펄스',
      Thunderkick: '썬더킥',
      retrogames: '레트로 게임즈',
      Mobilots: '모빌롯츠',
      PlayStar: '플레이 스타',
      caletagaming: '카르타 게이밍',
      netgame: '넷 게임',
      'Relax Gaming': '릴렉스 게이밍',
      'Dragoon Soft': '드라군 소프트',
      '1X2 Gaming': '1X2 게이밍',
      fils: '필스',
      smartsoft: '스마트 소프트',
      mancala: '만칼라',
      onetouch: '원터치',
      popok: '포폭',
      'Triple Profit Gaming': '트리플 프로핏 게이밍',
      quickspin: '퀵스핀',
      7777: '7777',
      'classic casino': '클래식 카지노',
      '7-mojos-slots': '세븐 모조스 슬롯',
      iconix: '아이코닉',
      macaw: '마카우',
      BigTimeGaming: '빅타임 게이밍',
      galaxsys: '갤럭시스',
      Skywind: '스카이윈드',
      jili: '질리',
    },
    nx: {
      pragmatic_slot: '프라그마틱 플레이',
      cq9_slot: '씨큐나인',
      playngo_slot: '플레이앤고',
      skywind_slot: '스카이윈드',
      evolution_redtiger: '레드타이거',
      wazdan_slot: '와즈단',
      evo_slot: '에보플레이',
      endorphina_slot: '엔도르피나',
      habanero_slot: '하바네로',
      netent_slot: '넷엔트',
      pgsoft_slot: 'PG소프트',
      funkegames_slot: '펀키게임즈',
      booongo_slot: '부운고',
      bgaming_slot: '비게이밍',
      hs_slot: '핵소우',
      nlc_slot: '노리밋 시티',
      playson_slot: '플레이손',
      relax_slot: '릴렉스 게이밍',
      ag_slot: '아시안 게이밍',
      mggrand_slot: '마이크로게이밍 그랜드',
      ps_slot: '플레이스타',
      booming_slot: '부밍 게임즈',
      dragoonsoft_slot: '드래곤소프트',
      btg_slot: '빅타임 게이밍',
      netgaming: '넷게이밍',
      blueprint_slot: '블루프린트',
    },
    sk: {
      'PRAGMATIC(SLOT)': '프라그마틱 플레이',
      1: '프라그마틱 플레이',
      SKYWIND: '스카이윈드',
      REDTIGER: '레드 타이거',
      YGGDRASIL: '이그드라실',
      DIR_WAZDAN: '와즈단',
      DIR_CQ9: '씨큐나인',
      2: '씨큐나인',
      PGSOFT: 'PG소프트',
      3: 'PG소프트',
      DIR_EVOPLAY: '에보플레이',
      HABANERO: '하바네로',
      7: '하바네로',
      MGSLOT: '마이크로 게이밍',
      NOLIMITCITY: '노리밋 시티',
      DIR_HACKSAW: '핵쏘',
      DIR_BOOONGO: '부운고',
      4: '부운고',
      DIR_RELAX: '릴렉스 게이밍',
      NETENT: '넷엔트',
      ONETOUCH: '원터치',
      BIGTIMEGAMING: '빅타임 게이밍',
    },
    sc: {
      1: '프라그마틱 플레이',
      2: '씨큐나인',
      3: 'PG소프트',
      4: '부운고',
      5: '플레이손',
      7: '하바네로',
      9: '질리',
    },
    gp: {
      1: '프라그마틱 플레이',
      2: '씨큐나인',
      3: 'PG소프트',
      4: '부운고',
      5: '플레이손',
      7: '하바네로',
      9: '질리',
      pragmaticplay: '프라그마틱 플레이',
      cq9: '씨큐나인',
      hbn: '하바네로',
      pg: 'PG 소프트',
      Hacksaw: '핵쏘',
      dreamtech: '드림테크',
      bng: '부운고',
      playson: '플레이손',
    },
  };
  providerTitle.po = { ...providerTitle.sc };

  document.querySelector('#slotModal').dataset.provider = provider;
  document.querySelector('#slotModal .modal-body .row').innerHTML = '';
  $.ajax({
    method: 'POST',
    url: '/game/list',
    data: { type: 'slot', provider: provider, pageNumber: pageNumber },
  })
    .done(function (result) {
      const { reqList, api_type } = result;
      document.querySelector('#slotModal .modal-title').innerHTML = providerTitle[api_type]?.[provider];

      insertGameBanner(reqList);
    })
    .fail(function (err) {
      console.log(err);
    });
});

$('#slotModal').on('hide.bs.modal', function () {
  document.querySelector('#slotModal .modal-body .row').innerHTML = '';
  pageNumber = 1;
});

function insertGameBanner(gameList) {
  const gameModal = document.querySelector(`#slotModal .modal-body .row`);

  gameList.forEach((game) => {
    if (!game.img_url.includes('https://')) {
      game.img_url = 'https://' + game.img_url;
    }

    let newBanner;
    if (game.provider_name) {
      game.provider_name = game.provider_name.replace('_slot', '').toUpperCase();
      if (game.provider_name == '1') game.provider_name = '프라그마틱 플레이';

      let overlay = `
      `;

      newBanner = `
      <div class="col-4 col-md-3 col-lg-2 text-center slot-banner">
        <img src="${game.img_url}" class="w-100 slot-icon" />
        <div class="title">${game.title}</div>
        <div class="overlay mx-auto">
        <div class="name">${game.title}</div>
        <a href="#"
          class="instanceBanner"
          data-game_id="${game.uuid}"
          data-provider="${game.provider}"
          data-game_type="slot"
          data-use_state="${game.display}"
        >
          <i class="bi bi-play-circle-fill play"></i>
        </a>
        <div class="provider">${game.provider_name}</div>
      </div>
      </div>`;
    } else {
      if (game.provider == '1') game.provider_name = '프라그마틱 플레이';

      newBanner = `
      <div class="col-4 col-md-3 col-lg-2 text-center slot-banner">
      <img src="${game.img_url}" class="slot-icon" />
            <div class='title'>${game.title}</div>
      <div class="overlay mx-auto img-thumbnail">
      <div class="name">${game.title}</div>
      <a href="#" class="instanceBanner" data-game_id="${game.uuid}" data-provider="${game.provider}" data-game_type="slot" data-use_state="${game.display}"
>
        <i class="bi bi-play-circle-fill play"></i>
        </a>    
        <div class="provider"></div>
        </div>
      </div>`;
    }

    gameModal.insertAdjacentHTML('beforeend', newBanner);
    // gameModal.innerHTML += newBanner;
  });
  // 모달안에 게임배너 만들고 이벤트리스너 추가
  addEventListenersToGameStartButtons('instanceBanner');
}
// #endregion

// #region 미니게임
let isMini;
let miniInfoArr;
let reloadIntervalId;

async function getMinigameList() {
  try {
    const result = await $.ajax({
      method: 'POST',
      url: '/game/mini/list',
    });

    return result.map((item) => {
      let type;
      if (item.type === 1) {
        type = 'ball';
      } else if (item.type === 2) {
        type = 'ladder';
      }

      return {
        title: item.title,
        gameId: item.gameId,
        type: type,
        interval: item.interval_time,
        iframe: item.relay_url,
        isDuplicateAllowed: item.isDuplicateAllowed,
        isMulti: item.isMulti,
        isOpen: item.isOpen,
        maxBetting: item.maxBetting,
        minBetting: item.minBetting,
        ratio: item.ratio,
        open_offset: item.open_offset,
        close_offset: item.close_offset,
      };
    });
  } catch (err) {
    console.error('에러 발생:', err);
    return [];
  }
}

// #region 미니게임 배너생성
checkMiniMode();
async function checkMiniMode() {
  try {
    const result = await $.ajax({
      method: 'POST',
      url: '/game/mini/check',
    });

    isMini = result;
  } catch (err) {
    console.error('에러 발생:', err);
    return [];
  }
}

(async () => {
  miniInfoArr = await getMinigameList();
  makeMiniBanner(miniInfoArr);

  setInterval(async () => {
    const updatedMiniInfoArr = await getMinigameList();

    if (JSON.stringify(miniInfoArr) !== JSON.stringify(updatedMiniInfoArr)) {
      miniInfoArr = updatedMiniInfoArr;
      makeMiniBanner(miniInfoArr);
    }
  }, 1000 * 60);
})();

function makeMiniBanner(miniInfoArr) {
  const navMiniList = document.querySelector('#navMiniList');
  navMiniList.innerHTML = '';

  const generateMiniBanner = (title, gameId, type, interval) => {
    return `
        <div class="col mini-banner">
          <div class="image-container">
            <div class="overlay">
              <div class="name">${title}</div>
              <a href="#" class="openMiniModal" 
                data-gameId="${gameId}" 
                data-type="${type}" 
                data-interval="${interval}">
                <i class="bi bi-play-circle-fill play"></i>
              </a>                            
            </div>
            <img src="/public/images/mini/mini_${gameId}.png" 
                class="w-100 rounded-3 main-image" />               
          </div>
        </div>`;
  };

  // 메인 로직
  miniInfoArr.forEach((mini) => {
    const { title, gameId, type, interval } = mini;
    const newList = generateMiniBanner(title, gameId, type, interval);
    navMiniList.innerHTML += newList;
  });
}
// #endregion

// #region 모달 내 변수, 상수 및 DOM 요소
let timerInterval = null;
let bettingData = null;
let isAmountButtonsInitialized = false;
let isSubmitButtonInitialized = false;
// let isConfirmButtonInitialized = false;
let alertContent = document.getElementById('alert-text');
let miniSubmitText = document.getElementById('mini-submit-text');
let miniConfirmText = document.getElementById('mini-confirm-text');

const singleBet = ['ballBetSelector', 'ladderBetSelector'];
const multiBet = [
  'powerOddEven',
  'powerUnderOver',
  'normalOddEven',
  'normalUnderOver',
  'ladderOddEven',
  'ladderLeftRight',
  'ladderThreeFour',
];
const typeMappings = {
  p1: { typeName: '파홀', color: 'primary' },
  p2: { typeName: '파짝', color: 'danger' },
  pu: { typeName: '파언더', color: 'primary' },
  po: { typeName: '파오버', color: 'danger' },
  n1: { typeName: '일홀', color: 'primary' },
  n2: { typeName: '일짝', color: 'danger' },
  nu: { typeName: '일언더', color: 'primary' },
  no: { typeName: '일오버', color: 'danger' },
  lo: { typeName: '홀', color: 'primary' },
  le: { typeName: '짝', color: 'danger' },
  ll: { typeName: '좌', color: 'primary' },
  lr: { typeName: '우', color: 'danger' },
  l3: { typeName: '삼', color: 'primary' },
  l4: { typeName: '사', color: 'danger' },
};

const miniModal = document.getElementById('miniModal');
const miniGameId = document.getElementById('miniGameId');
const modalTitle = document.querySelector('#miniModal .modal-title');
const modalBodyRelay = document.querySelector('#miniModal .modal-body .row .relaySection');
const round = document.querySelector('#miniModal #miniRound');
const timer = document.querySelector('#miniModal #remainTimer');
const lockScreen = document.querySelector('#miniModal .betLockScreen');

const selectedBet = document.getElementById('selectedBetType');
const expectedRatio = document.getElementById('expectedRatio');
const expectedWinAmount = document.getElementById('expectedWinAmount');
const miniBetAmountInput = document.getElementById('miniBetAmount');
const betButtons = document.querySelectorAll('.ballBetSelector .btn, .ladderBetSelector .btn');
const amountButtons = document.querySelectorAll('.amountSelector .btn');
const miniSubmitButton = document.getElementById('miniSubmitBtn');
const miniConfirmButton = document.getElementById('miniConfirmBtn');

// #endregion

// #region 미니게임 모달생성
navMiniList.addEventListener('click', async (event) => {
  let iframeReloadInterval;

  if (!clientId) {
    $('#notLoginModal').modal('show');
    return;
  }

  const target = event.target.closest('a.openMiniModal');
  if (!target) return;

  const gameId = target.getAttribute('data-gameId');
  const selectedGame = miniInfoArr.find((el) => el.gameId === gameId);
  const {
    title,
    interval,
    iframe,
    type,
    isDuplicateAllowed,
    isMulti,
    isOpen,
    maxBetting,
    minBetting,
    ratio,
    close_offset,
    open_offset,
  } = selectedGame;

  if (isOpen === 0) {
    alertContent.innerHTML = `<div class='content'>현재 베팅이 불가능한 게임입니다.</div>`;
    $('#alertModal').modal('show');
    return;
  }

  miniGameId.textContent = gameId;
  miniGameId.classList.add('d-none');
  modalTitle.textContent = `${title} - ${interval}분`;
  modalBodyRelay.innerHTML = iframe || `<p>Sorry, no content available for ${title}.</p>`;
  if (type === 'ball') {
    document.querySelector('.betSection .ballBetSelector').classList.remove('d-none');
    document.querySelector('.betSection .ladderBetSelector').classList.add('d-none');
  } else if (type === 'ladder') {
    document.querySelector('.betSection .ladderBetSelector').classList.remove('d-none');
    document.querySelector('.betSection .ballBetSelector').classList.add('d-none');
  }

  if (timerInterval) clearInterval(timerInterval);
  countDown(interval, close_offset, open_offset);
  timerInterval = setInterval(() => countDown(interval, close_offset, open_offset), 1000);

  initializeBettingSections(isMulti === 0 ? singleBet : multiBet);
  initializeBettingButtons(betButtons, selectedBet, ratio);
  initializeAmountButtons(amountButtons, expectedWinAmount, miniBetAmountInput, maxBetting, minBetting);
  initializeMiniSubmitButton(miniSubmitButton, isDuplicateAllowed);
  closeMiniModal();
  initBetResultTable('miniModalTable', gameId);

  if (reloadIntervalId) clearInterval;
  reloadIntervalId = setInterval(() => {
    $('#miniModalTable').DataTable().ajax.reload(null, false);
  }, 5000);

  // 중계 자동 새로고침
  // if (iframeReloadInterval) clearInterval(iframeReloadInterval);
  // iframeReloadInterval = setInterval(() => {
  //   modalBodyRelay.innerHTML = iframe || `<p>Sorry, no content available for ${title}.</p>`;
  // }, 20000);

  const reloadButton = document.querySelector('.mini-reload');
  reloadButton.addEventListener('click', () => {
    modalBodyRelay.innerHTML = iframe || `<p>Sorry, no content available for ${title}.</p>`;
  });

  const bootstrapModal = new bootstrap.Modal(miniModal);
  bootstrapModal.show();
});
// #endregion

// #region 타이머
async function countDown(interval, close_offset, open_offset) {
  const now = moment.utc().tz('Asia/Seoul');
  const startOfDay = moment().startOf('day');
  const intervalMinutes = interval;
  const maxRoundsPerDay = Math.floor((24 * 60) / intervalMinutes);
  const elapsedMinutes = now.diff(startOfDay, 'minutes');
  const currentRound = Math.floor(elapsedMinutes / intervalMinutes) + 1;
  const currentRoundStartTime = startOfDay.clone().add((currentRound - 1) * intervalMinutes, 'minutes');
  const nextRoundStartTime = currentRoundStartTime.clone().add(intervalMinutes, 'minutes');

  // 닫힘 시간과 열림 시간 계산
  const closeTime = nextRoundStartTime.clone().subtract(close_offset, 'seconds');
  const openTime = nextRoundStartTime.clone().subtract(open_offset, 'seconds');

  // 현재 상태 계산
  const isClosed = now.isBetween(closeTime, openTime);
  const isOpenForNextRound = now.isAfter(openTime);

  // 라운드 계산 (다음 라운드가 최대 라운드를 초과하면 1로 초기화)
  const displayRound = isOpenForNextRound ? (currentRound + 1 > maxRoundsPerDay ? 1 : currentRound + 1) : currentRound;

  // 남은 시간 계산
  const remainingTimeInSeconds = closeTime.diff(now, 'seconds');
  const minutes = Math.floor(Math.max(remainingTimeInSeconds, 0) / 60);
  const seconds = Math.max(remainingTimeInSeconds, 0) % 60;
  const remainingTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  // 상태에 따른 UI 업데이트
  round.innerHTML = `[제 ${displayRound} 회차]`;

  if (isClosed) {
    timer.innerHTML = '베팅 종료';
    lockScreen.classList.add('show');
    miniSubmitButton.disabled = true;
    miniConfirmButton.disabled = true;
    clearMiniModal();
    $('#miniSubmitModal').modal('hide');
  } else {
    timer.innerHTML = `${remainingTime}`;
    lockScreen.classList.remove('show');
    miniSubmitButton.disabled = false;
    miniConfirmButton.disabled = false;
  }
}

// #endregion

// #region 베팅 섹션 초기화
function initializeBettingSections(sections) {
  sections.forEach((sectionClass) => {
    const buttons = document.querySelectorAll(`.${sectionClass} button`);

    buttons.forEach((button) => {
      if (!button.dataset.listenerAttached) {
        button.addEventListener('click', () => {
          if (button.classList.contains('active')) {
            button.classList.remove('active');
          } else {
            buttons.forEach((btn) => btn.classList.remove('active'));
            button.classList.add('active');
          }
        });
        button.dataset.listenerAttached = true;
      }
    });
  });
}
// #endregion

// #region 베팅 버튼 초기화
function initializeBettingButtons(betButtons, selectedBet, betRatio) {
  betButtons.forEach((button) => {
    const isLadder = ['ll', 'lr', 'l3', 'l4', 'lo', 'le'].includes(button.dataset.betType);

    button.dataset.betRatio = betRatio;
    if (!isLadder) {
      const [ballPart] = button.innerHTML.split('<br>');
      button.innerHTML = `${ballPart}<br />x${betRatio}`;
    } else {
      const [ladderPart] = button.innerHTML.split(' x');
      button.innerHTML = `${ladderPart} x${betRatio}`;
    }

    button.addEventListener('click', (e) => {
      const activeButtons = document.querySelectorAll('.btn.active');
      let totalRatio = 1;
      selectedBet.innerHTML = '';

      activeButtons.forEach((activeButton) => {
        const ratio = parseFloat(activeButton.dataset.betRatio);
        if (!isNaN(ratio)) {
          totalRatio = parseFloat((totalRatio * ratio).toFixed(10));
        }

        let type = activeButton.dataset.betType;
        const { typeName, color } = typeMappings[type] || {};
        const existingButton = selectedBet.querySelector(`.${type}`);

        if (!existingButton) {
          selectedBet.innerHTML += `
        <div class="btn btn-${color} ${type}" data-bet-type="${type}">${typeName}</div>
      `;
        }
      });

      expectedRatio.textContent = totalRatio.toFixed(2);
      const miniBetAmount = parseInt(miniBetAmountInput.value.replace(/,/g, ''), 10) || 0;
      expectedWinAmount.textContent = `${Math.round(miniBetAmount * totalRatio.toFixed(2)).toLocaleString('ko-KR')} 원`;
    });
  });
}
// #endregion

// #region 금액 버튼 초기화
function checkBettingRange(amount, minBetting, maxBetting) {
  const betRangeText = `
          <div class='sub-title'>[ 베팅금액 안내 ]</div>
          <div class='content'>
          최소 베팅금액: ${minBetting.toLocaleString('ko-KR')}원<br>
          최대 베팅금액: ${maxBetting.toLocaleString('ko-KR')}원
          </div>`;

  if (amount < minBetting || amount > maxBetting) {
    document.getElementById('alert-text').innerHTML = betRangeText;
    miniBetAmountInput.value = '';
    expectedWinAmount.textContent = '';
    $('#alertModal').modal('show');
    return true;
  }
  return false;
}

function initializeAmountButtons(amountButtons, expectedWinAmount, miniBetAmountInput, maxBetting, minBetting) {
  if (isAmountButtonsInitialized) return;
  isAmountButtonsInitialized = true;

  amountButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const wonValue = button.dataset.won;
      const miniUserBalance = parseInt(document.getElementById('miniUserBalance').innerHTML.replace(/,/g, ''), 10);
      const expectedRatio = parseFloat(document.getElementById('expectedRatio').textContent || 0);

      if (wonValue === 'reset') {
        miniBetAmountInput.value = 0;
        expectedWinAmount.textContent = 0;
        return;
      }

      if (wonValue === 'half') {
        const halfBalance = Math.floor(miniUserBalance / 2);
        if (checkBettingRange(halfBalance, minBetting, maxBetting)) return;
        miniBetAmountInput.value = halfBalance.toLocaleString('ko-KR');
        expectedWinAmount.textContent = `${Math.round(halfBalance * expectedRatio).toLocaleString('ko-KR')} 원`;
        return;
      }

      if (wonValue === 'max') {
        if (checkBettingRange(miniUserBalance, minBetting, maxBetting)) return;
        miniBetAmountInput.value = miniUserBalance.toLocaleString('ko-KR');
        expectedWinAmount.textContent = `${Math.round(miniUserBalance * expectedRatio).toLocaleString('ko-KR')} 원`;

        return;
      }

      const amount = parseInt(wonValue, 10);
      if (!isNaN(amount)) {
        const currentBet = parseInt(miniBetAmountInput.value.replace(/,/g, ''), 10) || 0;
        const newBet = currentBet + amount * 1000;
        if (checkBettingRange(newBet, minBetting, maxBetting)) return;
        if (newBet > miniUserBalance) {
          document.getElementById('alert-text').innerHTML = `
        <div class='sub-title'>[ 보유금 초과 ]</div>
        <div class='content'>[MAX 베팅] 으로 변경합니다</div>
        `;
          $('#alertModal').modal('show');
          miniBetAmountInput.value = miniUserBalance.toLocaleString('ko-KR');
          expectedWinAmount.textContent = `${Math.round(miniUserBalance * expectedRatio).toLocaleString('ko-KR')} 원`;
        } else {
          miniBetAmountInput.value = newBet.toLocaleString('ko-KR');
          expectedWinAmount.textContent = `${Math.round(newBet * expectedRatio).toLocaleString('ko-KR')} 원`;
        }
      }
    });
  });

  miniBetAmountInput.addEventListener('change', () => {
    let inputValue = parseInt(miniBetAmountInput.value.replace(/,/g, ''), 10) || 0;
    miniUserBalance = parseInt(document.getElementById('miniUserBalance').innerHTML.replace(/,/g, ''), 10);
    if (checkBettingRange(inputValue, minBetting, maxBetting)) return;
    if (inputValue > miniUserBalance) {
      document.getElementById('alert-text').innerHTML = `
    <div class='fs-5'>보유금을 초과했습니다</div>
    <div class='fs-5 mt-2'>[MAX 베팅] 으로 변경합니다</div>
    `;
      $('#alertModal').modal('show');
      inputValue = miniUserBalance;
    }

    miniBetAmountInput.value = inputValue.toLocaleString('ko-KR');
    expectedWinAmount.textContent = `${Math.round(
      inputValue * parseFloat(expectedRatio.textContent) || 0
    ).toLocaleString('ko-KR')} 원`;
  });
}
// #endregion

// #region 서브밋 버튼 초기화
// 데이터베이스에서 중복된 베팅내역이 있는지 확인
async function findDuplicateBetting(params) {
  params.round = params.round.match(/\d+/)[0];

  try {
    const result = await $.ajax({
      method: 'POST',
      url: '/game/mini/duplicate',
      data: params,
    });

    return result;
  } catch (err) {
    console.error('에러 발생:', err);
    return false;
  }
}

function initializeMiniSubmitButton(miniSubmitButton, isDuplicateAllowed) {
  if (isSubmitButtonInitialized) return;
  isSubmitButtonInitialized = true;

  miniSubmitButton.addEventListener('click', async () => {
    const selectedButtons = selectedBet.querySelectorAll('.btn');
    const betTypes = Array.from(selectedButtons).map((button) => button.dataset.betType);

    bettingData = {
      round: round.textContent,
      gameType: miniGameId.textContent,
      selectedBets: betTypes,
      ratio: parseFloat(expectedRatio.textContent),
      expectedWinAmount: parseInt(expectedWinAmount.textContent.replace(/[^0-9]/g, ''), 10),
      betAmount: parseInt(miniBetAmountInput.value.replace(/[^0-9]/g, ''), 10),
    };

    if (isDuplicateAllowed === 0) {
      let isExist = await findDuplicateBetting(bettingData);
      if (isExist) {
        alertContent.innerHTML = `
        <div class='content'>이번회차 이미 베팅된 내역이 있습니다</div>`;
        clearMiniModal();
        $('#alertModal').modal('show');
        return;
      }
    }

    if (
      !bettingData.gameType ||
      bettingData.selectedBets.length === 0 ||
      bettingData.ratio === 0 ||
      bettingData.expectedWinAmount === 0 ||
      bettingData.betAmount === 0
    ) {
      alertContent.innerHTML = `
    <div class='content'>베팅 정보를 확인해주세요</div>
    `;
      $('#alertModal').modal('show');
      return;
    }

    if (lockScreen.classList.contains('show')) {
      alertContent.innerHTML = `
    <div class='content'>베팅이 종료되었습니다</div>
    `;
      $('#alertModal').modal('show');
      return;
    }

    if (bettingData.betAmount > miniUserBalance) {
      alertContent.innerHTML = `
    <div class='content'>보유금을 초과했습니다</div>
    `;
      $('#alertModal').modal('show');
      return;
    }

    miniSubmitText.innerHTML = `
        <div class='fs-5'>베팅 하시겠습니까?</div>
    `;
    $('#miniSubmitModal').modal('show');
  });
}

document.getElementById('miniConfirmBtn').addEventListener('click', () => {
  spinnerToggle();
  // if (isConfirmButtonInitialized) return;
  // isConfirmButtonInitialized = true;

  $.ajax({
    method: 'POST',
    url: '/game/mini/bet',
    data: bettingData,
  }).done(function (result) {
    spinnerToggle();
    clearMiniModal();
    miniConfirmText.innerHTML = `
      <div class='fs-5'>${result.msg}</div>
    `;
    $('#miniConfirmModal').modal('show');
  });
});
// #endregion

// #region 모달 정리 및 닫기
function closeMiniModal() {
  miniModal.addEventListener('hidden.bs.modal', () => {
    modalBodyRelay.innerHTML = '';

    if (reloadIntervalId) {
      clearInterval(reloadIntervalId);
      reloadIntervalId = null;
    }

    // 타이머 정리
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }

    if ($.fn.DataTable.isDataTable('#miniModalTable')) {
      $('#miniModalTable').DataTable().destroy();
    }

    clearMiniModal();
    startDate = moment().format('YYYY-MM-DD');
    endDate = moment().format('YYYY-MM-DD');
  });
}

function clearMiniModal() {
  selectedBet.innerHTML = '';
  expectedRatio.textContent = '';
  expectedWinAmount.textContent = '';
  miniBetAmountInput.value = '';

  const activeButtons = document.querySelectorAll('.btn.active');
  activeButtons.forEach((button) => {
    button.classList.remove('active');
  });
}
// #endregion

// #region 미니게임 베팅내역

let startDate = moment().format('YYYY-MM-DD');
let endDate = moment().format('YYYY-MM-DD');
const userBetResultModal = document.getElementById('betResultModal');

userBetResultModal.addEventListener('shown.bs.modal', () => {
  initBetResultTable('resultModalTable');

  if ($('#resultModalTable').DataTable()) {
    reloadIntervalId = setInterval(() => {
      $('#resultModalTable').DataTable().ajax.reload(null, false);
    }, 5000);
  }
});

userBetResultModal.addEventListener('hidden.bs.modal', () => {
  const tableSelector = '#resultModalTable';

  if (reloadIntervalId) {
    clearInterval(reloadIntervalId);
    reloadIntervalId = null;
  }

  if ($.fn.DataTable.isDataTable(tableSelector)) {
    $(tableSelector).DataTable().destroy();
    startDate = moment().format('YYYY-MM-DD');
    endDate = moment().format('YYYY-MM-DD');
  }
});

function initBetResultTable(tableName, type = '') {
  const selector = `#${tableName.trim()}`;
  const table = $(selector);
  let domSetting = '';

  if (type == '') {
    domSetting =
      '<"dateInput float-start dateWidth me-2"><"ms-4 btn btn-sm asset-success all"><"ms-1 btn btn-sm asset-primary bb"><"ms-1 btn btn-sm asset-primary nb"><"ms-1 btn btn-sm asset-primary db"><"ms-1 btn btn-sm asset-primary eb"><"ms-1 btn btn-sm asset-danger bl"><"ms-1 btn btn-sm asset-danger nl"><"ms-1 btn btn-sm asset-danger dl"><"ms-1 btn btn-sm asset-danger el">lfrtip';
  } else {
    domSetting = '<"dateInput float-start dateWidth me-2">lfrtip';
  }

  return table.DataTable({
    language: korean,
    responsive: true,
    autoWidth: true,
    // scrollY: '65vh',
    // scrollCollapse: true,
    ajax: {
      url: '/game/result',
      // beforeSend: function () {
      //   spinnerToggle(true);
      // },
      // complete: function () {
      //   spinnerToggle(false);
      // },
      method: 'POST',
      data: function (d) {
        d.startDate = startDate;
        d.endDate = endDate;
        d.type = 'mini';
        return d;
      },
      error: function (xhr, error, code) {
        console.error('DataTables Ajax Error:', xhr, error, code);
      },
      dataSrc: '',
    },
    dom: domSetting,
    columns: [
      { data: 'IDX' },
      { data: '발생시간', className: 'desktop' },
      { data: '처리시간', className: 'desktop' },
      { data: '아이디', className: 'desktop' },
      { data: '게임명', className: 'desktop' },
      { data: '회차', responsivePriority: 1 },
      { data: '베팅종류', responsivePriority: 2 },
      { data: '베팅시보유금', className: 'desktop' },
      { data: '배당률', className: 'desktop' },
      { data: '예상당첨금', responsivePriority: 4 },
      { data: '베팅금액', responsivePriority: 3 },

      { data: '베팅후보유금', className: 'desktop' },
      { data: '결과', responsivePriority: 5 },
      { data: '지급', responsivePriority: 6 },
      { data: 'node_id' },
    ],
    pageLength: 10,
    lengthMenu: [10, 50, 100],
    order: [[0, 'desc']],
    createdRow: function (row, data, dataIndex) {
      if (data.결과 == 1) {
        $(row).addClass('bg-mistyred');
      }
    },
    columnDefs: [
      {
        target: [0, 3, 14],
        visible: false,
      },
      {
        target: [0, 1, 2, 3, 4, 5, 6, 14],
        orderable: false,
      },
      {
        target: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        className: 'dt-head-center',
      },
      {
        target: [7, 9, 10, 11],
        className: 'dt-body-right',
      },
      {
        target: [1, 2, 3, 4, 5, 6, 8, 12, 13],
        className: 'dt-body-center',
      },
      // {
      //   target: 1,
      //   render: function (data) {
      //     return data.slice(2).replace('T', '&nbsp;&nbsp;&nbsp;').replace('.000Z', '');
      //   },
      // },
      // {
      //   target: 2,
      //   render: function (data) {
      //     data = String(data);
      //     if (data == 'null') {
      //       return '';
      //     } else {
      //       return data.slice(2).replace('T', '&nbsp;&nbsp;&nbsp;').replace('.000Z', '');
      //     }
      //   },
      // },
      {
        target: 1,
        render: function (data) {
          const formattedDate = data.slice(0, 10); // yyyy-mm-dd
          const formattedTime = data.slice(11, 19); // hh:mm:ss
          return `${formattedDate}<br>${formattedTime}`;
        },
      },
      {
        target: 2,
        render: function (data) {
          data = String(data);
          if (data === 'null') {
            return '';
          } else {
            const formattedDate = data.slice(0, 10); // yyyy-mm-dd
            const formattedTime = data.slice(11, 19); // hh:mm:ss
            return `${formattedDate}<br>${formattedTime}`;
          }
        },
      },

      {
        target: 3,
        render: function (data, type, row) {
          return `<a class='id-btn'>${data}</a>`;
        },
      },
      {
        target: 4,
        render: function (data) {
          switch (data) {
            case 'bb':
              return '보글 파워볼(2)';
            case 'bl':
              return '보글 사다리(3)';
            case 'nb':
              return 'N 파워볼(5)';
            case 'nl':
              return 'N 파워사다리(5)';
            case 'db':
              return '동행 파워볼(5)';
            case 'dl':
              return '동행 사다리(5)';
            case 'eb':
              return '이오스 파워볼(5)';
            case 'el':
              return '엔트리 파워사다리(5)';
          }
        },
      },
      {
        target: 6,
        render: function (data) {
          const typeMapping = {
            p1: '파홀',
            p2: '파짝',
            pu: '파언더',
            po: '파오버',
            n1: '일홀',
            n2: '일짝',
            nu: '일언더',
            no: '일오버',
            o: '홀',
            e: '짝',
            l: '좌출',
            r: '우출',
            3: '3줄',
            4: '4줄',
          };

          const cleanedData = data.replace(/[\[\]]/g, '').split(',');

          const buttons = cleanedData.map((item) => {
            const key = item.replace(/"/g, '');
            const mappedValue = typeMapping[key] || key;

            const btnClass = ['홀', '언더', '좌', '3'].some((key) => mappedValue.includes(key))
              ? 'btn-primary'
              : 'btn-danger';

            return `<button type='button' class='btn btn-sm ${btnClass}' style='pointer-events: none'>${mappedValue}</button>`;
          });

          return buttons.join(' ');
        },
      },
      {
        target: [7, 9, 10, 11],
        render: $.fn.dataTable.render.number(','),
      },
      {
        target: 9,
        className: 'fw-bold',
      },
      {
        target: 12,
        render: function (data) {
          if (data == 0) {
            return `<button type='button' class='btn btn-sm asset-success' style='pointer-events: none'>대기</button>`;
          } else if (data == 1) {
            return `<button type='button' class='btn btn-sm asset-primary' style='pointer-events: none'>적중</button>`;
          } else if (data == 2) {
            return `<button type='button' class='btn btn-sm asset-danger' style='pointer-events: none'>미적중</button>`;
          } else {
            return '';
          }
        },
      },
      {
        target: 13,
        render: function (data) {
          if (data == 1) {
            return `<button type='button' class='btn btn-sm asset-danger' style='pointer-events: none'>미지급</button>`;
          } else if (data == 2) {
            return `<button type='button' class='btn btn-sm asset-primary' style='pointer-events: none'>완료</button>`;
          } else {
            return '';
          }
        },
      },
    ],
    initComplete: function () {
      if (document.querySelector('.dateInput')) {
        document.querySelector('.dateInput').innerHTML =
          '<input type="text" class="text-center w-100" style="padding: 3px 0" id="dateSelector" name="date" value=""/>';
        $(function () {
          $('#dateSelector').daterangepicker(commonOptions, dateFormatCallback, {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          });
        });
      }

      const buttons = {
        all: '전체',
        bb: '보글 파워볼(2)',
        nb: 'N 파워볼(5)',
        db: '동행 파워볼(5)',
        eb: '이오스 파워볼(5)',
        bl: '보글 사다리(3)',
        nl: 'N 파워사다리(5)',
        dl: '동행 사다리(5)',
        el: '엔트리 파워사다리(5)',
      };

      if (type) {
        this.api().search(buttons[type]).draw();
        this.api().column(4).visible(false);
      } else {
        for (let [key, value] of Object.entries(buttons)) {
          const btn = document.querySelector(`.${key}`);
          if (btn) {
            btn.innerHTML = value;
            btn.addEventListener('click', () => {
              if (value == '전체') value = '';
              this.api().search(value).draw();
            });
          }
        }
      }
      this.api().columns.adjust();
    },
    drawCallback: function () {
      this.api().columns.adjust();
    },
  });
}

// #endregion

// #endregion

// #region 게임 시작
// 기존에 HTML에 직접 타이핑 된 요소에 이벤트 리스너 추가
addEventListenersToGameStartButtons('staticBanner');

function addEventListenersToGameStartButtons(className) {
  const gameStartButtons = document.querySelectorAll(`.${className}`);
  gameStartButtons.forEach((button) => {
    if (button.clickHandler) {
      button.removeEventListener('click', button.clickHandler);
    }

    button.clickHandler = (event) => {
      spinnerToggle();
      const gameId = event.currentTarget.dataset.game_id;
      const provider = event.currentTarget.dataset.provider;
      const gameType = event.currentTarget.dataset.game_type;
      const useState = event.currentTarget.dataset.use_state;
      sendGameStartRequest(gameId, provider, gameType, useState);
    };
    button.addEventListener('click', button.clickHandler);
  });
}

function sendGameStartRequest(gameId, provider, gameType, useState) {
  let isMobile = window.matchMedia('only screen and (max-width: 768px)').matches;

  $.ajax({
    method: 'POST',
    url: '/game/start',
    data: {
      gameId: gameId,
      provider: provider,
      gameType: gameType,
      platform: isMobile ? 'mobile' : 'desktop',
      useState: useState || 0,
    },
  })
    .done(function (result) {
      spinnerToggle();
      if (result.isError) {
        document.querySelector('#alertModal .modal-body').innerHTML = `
        <div class='fs-5'>현재 점검중인 게임입니다</div>
        `;
        $('#alertModal').modal('show');
        return;
      }

      let needNewWindow = checkProviderName(result.provider);
      if (result.apiType === 'po') needNewWindow = true;

      if (result.isLogin === true) {
        if (result.provider === 10) result.provider = '드림 게이밍';
        if (result.url && result.url !== '') {
          const gameLink = result.url;
          const gameType = result.gameType;
          if (isMobile) {
            $('#gameLinkModal').modal('show');
            document.getElementById('gameStartLink').href = result.url;
          } else if (needNewWindow) {
            // $('#gameLinkModal').modal('show');

            const windowWidth = window.screen.width * 0.7;
            const windowHeight = window.screen.height * 0.7;

            const left = (window.screen.width - windowWidth) / 2;
            const top = (window.screen.height - windowHeight) / 2;

            gamePopup = window.open(
              result.url,
              'gameWindow',
              `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`
            );
          } else {
            openGameWindow(result.title || result.provider, gameLink, gameType);
          }
        } else {
          $('#slotModal').modal('hide');
          document.querySelector(
            '#alertModal .modal-body'
          ).innerHTML = `<div class='fs-5'>현재 점검 중인 게임입니다</div>`;
          $('#alertModal').modal('show');
        }
      } else {
        $('#slotModal').modal('hide');
        $('#notLoginModal').modal('show');
      }
    })
    .fail(function (err) {
      console.log('AJAX 요청 실패:', err);
    });
}

function checkProviderName(provider) {
  switch (provider) {
    case 'evolution':
      return true;
    case 'playngo_slot':
      return true;
    case 'microgaming_slot':
      return true;
    case 'skywind_slot':
      return true;
    case 'endorphina_slot':
      return true;
    case 'pgsoft_slot':
      return true;
    case 'ps_slot':
      return true;
    case 'booming_slot':
      return true;
    case 'dragoonsoft_slot':
      return true;
    case 'btg_slot':
      return true;
    case 10:
      return true;
    case 'bbin_asia':
      return true;
    case 'bbin_asia':
      return true;
    case '6':
    case '10':
    case '11':
      return true;
    default:
      return false;
  }
}

function openGameWindow(title, url, type) {
  const windowWidth = window.screen.width * 0.7;
  const windowHeight = window.screen.height * 0.7;

  const left = (window.screen.width - windowWidth) / 2;
  const top = (window.screen.height - windowHeight) / 2;

  gamePopup = window.open('', 'gameWindow', `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`);

  gamePopup.document.open();
  gamePopup.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #000; }
          iframe { width: 100%; height: 100%; border: none; z-index: 9999;}
        </style>
      </head>
      <body>
        <iframe src="${url}"></iframe>
      </body>
    </html>
  `);
  gamePopup.document.close();
  gamePopup.focus();
}

$('#gamePlayModal').on('hide.bs.modal', function () {
  document.getElementById('gameIframe').src = '';
});

document.getElementById('gameStartLink').addEventListener('click', function () {
  setTimeout(() => {
    $('#gameStartLink').attr('href', '');
    $('#gameLinkModal').modal('hide');
  }, 3000);
});

if (document.getElementById('nav-sport-tab')) {
  document.getElementById('nav-sport-tab').addEventListener('click', async function () {
    $('#sportModal').modal('show');
  });

  document.getElementById('sport-start').addEventListener('click', async function () {
    spinnerToggle();
    sendGameStartRequest('live_sport', 'live-inplay', 'sport');
  });
}
// #endregion

// #region back-to-top
let mybutton = document.getElementById('btn-back-to-top');

// When the user scrolls down 20px from the top of the document, show the button
slotModal.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (slotModal.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = 'block';
  } else {
    mybutton.style.display = 'none';
  }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener('click', backToTop);

function backToTop() {
  slotModal.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
// #endregion
